import { TOKEN } from "@/types/common/ids";
import { Org, OrgRequest } from "@/types/org";
import { apiFetch } from "@/lib/api";
import { GAIL_API } from "@/utils/common/constants/routes";

export const UpdateOrg = async (
  org: OrgRequest,
  accessToken?: TOKEN
): Promise<Org | null> => {
  return await apiFetch<Org>(
    `${GAIL_API}/.internal/customer/organization`,
    "PATCH",
    {
      body: org,
      accessToken,
    }
  );
};
